module.exports = "../../../../platform/assets/pageMainIcon/baobiaochaxunlei5.svg";